import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=559f1402&scoped=true"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=559f1402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f1402",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemIcon,VTextField})
